   <div class="container p-6">
    <!-- <div class="mb-4">
      <h2 class="text-xl font-semibold">{{ 'DATE_RANGE_FILTER.TEXT' | translate }}</h2>
  </div> -->

     <!-- Filters Section -->
  <div class="mb-6">
    <h3 class="text-lg font-semibold mb-4">{{ 'DATE_RANGE_FILTER.TEXT' | translate }}</h3>
    <form [formGroup]="dateFilterForm" class="flex gap-4 items-center">
      <mat-form-field>
        <mat-label>{{ 'FROM.TEXT' | translate }}</mat-label>
        <input matInput [matDatepicker]="fromPicker" formControlName="fromDate">
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'TO.TEXT' | translate }}</mat-label>
        <input matInput [matDatepicker]="toPicker" formControlName="toDate">
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </form>
  </div>

 <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      <!-- Assistant Widget -->
    <vex-widget-assistant class="sm:col-span-2 md:col-span-full"></vex-widget-assistant>
    <!-- <vex-widget-quick-value-center
    icon="mat:account_balance_wallet"
    iconClass="text-primary-600 bg-primary-600/10"
    label="Customer Balance"
    [value]="reportData?.customerBalance?.toString()">
  </vex-widget-quick-value-center>

  <vex-widget-quick-value-center
    icon="mat:credit_card"
    iconClass="text-orange-600 bg-orange-600/10"
    label="Customer Credit Limit"
    [value]="reportData?.customerCrditLimit?.toString()">
  </vex-widget-quick-value-center> -->

    <!-- Large Goal Chart -->

    <vex-widget-large-goal-chart
      [series]="[{name:'orders count', data:ordersCount}]"
      [title]="'DAILY_COUNT.TEXT' | translate"
      class="sm:col-span-2"
      total="4,374"></vex-widget-large-goal-chart>

      <vex-widget-large-goal-chart
      [series]="[{name:'orders Amount (SAR)', data:ordersAmount}]"
    [title]="'DAILY_AMOUNT.TEXT' | translate"
      class="sm:col-span-2"
      total="4,374"></vex-widget-large-goal-chart>
  
    <!-- Quick Value Centers -->
    <!-- <vex-widget-quick-value-center
      icon="mat:group"
      iconClass="text-primary-600 bg-primary-600/10"
      label="Users"
      value="67.4k"></vex-widget-quick-value-center>
        -->
        
    
      <vex-widget-quick-value-center
        icon="mat:shopping_cart"
        iconClass="text-teal-600 bg-teal-600/10"
        [label]="'TOTAL_ORDERS.TEXT' | translate"
        [value]="reportData?.totalOrders?.toString()">
      </vex-widget-quick-value-center>
    
      <vex-widget-quick-value-center
      icon="mat:payments"
      iconClass="text-green-600 bg-green-600/10"
        [label]="'TOTAL_ORDERS_AMOUNT.TEXT' | translate"
        [value]="formatCurrency(reportData?.totalOrdersAmount)"
        [currencySymbol]="true">
      </vex-widget-quick-value-center>

      <vex-widget-quick-value-center
      icon="mat:local_shipping"
      iconClass="text-primary-600 bg-primary-600/10"
      [label]="'TOTAL_DELIVERIES.TEXT' | translate"
      [value]="reportData?.totalDeliveries?.toString()">
    </vex-widget-quick-value-center>
  
    <vex-widget-quick-value-center
    icon="mat:payments"
    iconClass="text-orange-600 bg-orange-600/10"
      [label]="'TOTAL_DELIVERIES_AMOUNT.TEXT' | translate"
      [value]="formatCurrency(reportData?.totalDeliveriesAmount)"
      [currencySymbol]="true">
    </vex-widget-quick-value-center>
  

    
      <!-- Table Widgets -->
      <vex-widget-table
      [title]="'TOP_SELLING_COUNT.TEXT' | translate"
      [columns]="QuntityTableColumns"
      [data]="reportData?.mostOrderedItemsByQuantity"
      class="sm:col-span-2"></vex-widget-table>

      <vex-widget-table
      [title]="'TOP_SELLING_AMOUNT.TEXT' | translate"
      [columns]="amountTableColumns"
      [data]="reportData?.mostOrderedItemsByAmount"
      class="sm:col-span-2"></vex-widget-table> 

  </div>
  